import Drawer from "global/components/drawer";

export default Drawer.Wrapper;
